import React, { useEffect } from "react";
import NavbarSection from "../NavBar/Navbar.js";
import EcoSysSecOne from "../../components/InlinePages/EcoSystem/EcoSysSecOne/EcoSysSecOne.js";
import FooterSection from "../NewFooter/Footer.js";
// import EcoSysSecTwo from "../InlinePages/EcoSystem/EcoSysSecTwo/EcoSysSecTwo.js";
import EcoSectiontwo from "../../components/InlinePages/EcoSystem/EcoSysSecTwo/EcoSectiontwo.js";
import EcoSectionThree from "../InlinePages/EcoSystem/EcoSysSecThree/Ecosectionthree.js";
import EcoSectionFour from "../InlinePages/EcoSystem/EcoSysSecFour/EcoSysSecFour.js";
import EcoSysSecFive from "../InlinePages/EcoSystem/EcoSysSecFive/EcoSysSecFive.js";
// import { useTheme } from "../../context/ThemeProvider.js";
function EcoSystem() {
  //   const { theme } = useTheme();

  document.title = "3VO | EcoSystem";

  useEffect(() => {
    // Function to handle auto-scrolling
    const handleAutoScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          let offset = element.getBoundingClientRect().top;
          if (hash === "#tokenomics") {
            offset += 140; // Add additional offset for #advisors
          }
          window.scrollTo({
            top: window.pageYOffset + offset - 70, // Adjusted for header
            behavior: "smooth",
          });
        }
      }
    };

    handleAutoScroll();
    window.addEventListener("hashchange", handleAutoScroll);

    return () => {
      window.removeEventListener("hashchange", handleAutoScroll);
    };
  }, []);

  return (
    <div>
      <div className="bg-pages">
        <NavbarSection />
        <EcoSysSecOne />
        {/* <EcoSysSecTwo /> */}
        <EcoSectiontwo />
        <EcoSectionThree />
        <EcoSectionFour />
        <EcoSysSecFive />
        <FooterSection />
      </div>
    </div>
  );
}

export default EcoSystem;
